// hooks/useServiceWorker.ts
// Hook per registrazione Service Worker PWA

'use client';

import { useEffect } from 'react';

export function useServiceWorker() {
  useEffect(() => {
    // Registra il service worker solo in produzione e se supportato
    if (
      typeof window !== 'undefined' &&
      'serviceWorker' in navigator &&
      process.env.NODE_ENV === 'production'
    ) {
      const registerSW = async () => {
        try {
          console.log('PWA: Registering service worker...');
          const registration = await navigator.serviceWorker.register('/sw.js', {
            scope: '/'
          });
          
          console.log('PWA: Service worker registered:', registration);

          // Controlla per aggiornamenti ogni 60 secondi
          setInterval(() => {
            registration.update();
          }, 60000);

          // Gestisci aggiornamenti del service worker
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  // Nuovo service worker disponibile
                  console.log('PWA: New service worker available');
                  
                  // Qui potresti mostrare una notifica all'utente
                  // per ricaricare la pagina per ottenere la nuova versione
                }
              });
            }
          });

        } catch (error) {
          console.error('PWA: Service worker registration failed:', error);
        }
      };

      registerSW();
    } else {
      console.log('PWA: Service worker not supported or in development mode');
    }
  }, []);
}